import { ArrowDownward, ArrowForward, ArrowUpward } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { SubroutineSortType } from '@/types/subroutine';

type SubroutineSortArrowProps = {
  sortSubroutinesBy: SubroutineSortType;
  onClose: (sortSubroutine: SubroutineSortType) => void;
};

const SubroutineSortArrow: FC<SubroutineSortArrowProps> = (props) => {
  const theme = useTheme();

  const getArrowType = () => {
    switch (props.sortSubroutinesBy) {
      case 'up':
        return (
          <ArrowUpward
            onClick={() => {
              props.onClose('default');
            }}
            fontSize='small'
          />
        );
      case 'down':
        return (
          <ArrowDownward
            onClick={() => {
              props.onClose('up');
            }}
            fontSize='small'
          />
        );
      default:
        return (
          <ArrowForward
            onClick={() => {
              props.onClose('down');
            }}
            fontSize='small'
          />
        );
    }
  };
  return (
    <Box sx={{ cursor: 'pointer', color: theme.palette.mode === 'dark' ? 'white' : 'black', padding: '5px' }}>
      {getArrowType()}
    </Box>
  );
};

export default SubroutineSortArrow;
